import links from "@/links/links";

export default {
  actions: {
    GET_BY_USER_ID(userId) {
      return this.get(links.MEETING_GUEST_GET_BY_USER_ID(userId), {
        dataKey: "hydra:member",
      });
    },
    FETCH() {
      return this.get(links.MEETING_GUESTS_FETCH(), {
        dataKey: "hydra:member",
      });
    },
  },
};
